import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';

import BasicTypeaheadPicker from './BasicTypeaheadPicker';

const ActionTypeaheadPicker = ({
  selectedValue = {},
  onChange = () => {},
  onTypeAction = async () => [],
  initialOptions = [],
  minTypeLength = 0,
  ...others
}) => {
  const [results, setResults] = useState(initialOptions);
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState(undefined);
  const [dropdownShowing, setDropdownShowing] = useState(false);
  const dispatch = useDispatch();
  const onType = async value => {
    setDropdownShowing(value.length > minTypeLength);
    setIsLoading(true);
    let items = [];
    let error;
    const result = await onTypeAction(value, dispatch);
    if (result === undefined || result === null) {
      setResults(initialOptions);
      setErrorMessage(undefined);
    } else if (Array.isArray(result)) {
      items = result;
    } else {
      ({ items, error } = result);
    }
    setResults(initialOptions.concat(items || []));
    setErrorMessage(error);
    setIsLoading(false);
  };
  const onDropdownDismiss = () => setDropdownShowing(false);
  const onDropdownClick = () => setDropdownShowing(!dropdownShowing);
  return (
    <BasicTypeaheadPicker
      selectedValue={selectedValue}
      options={results}
      isLoading={isLoading}
      onType={onType}
      onChange={onChange}
      error={errorMessage}
      showDropdown={dropdownShowing}
      onDropdownDismiss={onDropdownDismiss}
      onDropdownClick={onDropdownClick}
      {...others}
    />
  );
};

ActionTypeaheadPicker.propTypes = {
  selectedValue: PropTypes.shape({
    key: PropTypes.any.isRequired,
    text: PropTypes.string.isRequired,
  }),
  onChange: PropTypes.func,
  onTypeAction: PropTypes.func,
  initialOptions: PropTypes.array,
  minTypeLength: PropTypes.number,
};

ActionTypeaheadPicker.defaultProps = {
  selectedValue: null,
  onChange: () => {},
  onTypeAction: () => [],
  initialOptions: [],
  minTypeLength: 0,
};

export default ActionTypeaheadPicker;
